module.exports = __webpack_public_path__ + "img/publicity.a30a680.png";